// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:49:06

export default {
  "id": "real-car-parking-simulator",
  "slug": "real-car-parking-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6ddcb4f6691148499aa0dbdb682290bb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6ddcb4f6691148499aa0dbdb682290bb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Real Car Parking Simulator",
      "description": "Get ready to test your driving skills in Real Car Parking Simulator. In the parking simulation game, you will face various parking challenges. With realistic controls and detailed environments,you’ll feel like you're actually behind the wheel. From parallel parking to tight garage spaces,\nthis game offers many parking challenges.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "car",
        "challenge",
        "parking",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "真实汽车停车模拟器",
      "description": "准备好在《真实汽车停车模拟器》中测试你的驾驶技巧。在停车模拟游戏中，你将面临各种停车挑战。凭借逼真的控制和详细的场景，你将感觉自己真的坐在驾驶座上。从并排停车到狭窄的车库空间，这款游戏提供了许多停车挑战。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "模拟"
      ],
      "tags": [
        "汽车",
        "挑战",
        "停车",
        "技巧"
      ]
    },
    "zh-TW": {
      "title": "真實車輛停車模擬器",
      "description": "準備好測試你的駕駛技巧在《真實車輛停車模擬器》中。在這款停車模擬遊戲中，你將面對各種停車挑戰。透過真實的操控和細節豐富的環境，你將有如親自坐在駕駛座上。從並列停車到緊迫的車庫空間，這款遊戲提供了許多停車挑戰。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "模擬"
      ],
      "tags": [
        "車",
        "挑戰",
        "停車",
        "技巧"
      ]
    },
    "zh-HK": {
      "title": "真實汽車停車模擬器",
      "description": "準備好測試你的駕駛技巧於《真實汽車停車模擬器》。在停車模擬遊戲中，你將面對各種停車挑戰。具實際操控和細節豐富的環境，你會有如在駕駛座上的感覺。從並行停車到狹窄車庫空間，這款遊戲提供了許多停車挑戰。",
      "instructions": "用滑鼠點擊或觸控遊玩",
      "genres": [
        "模擬"
      ],
      "tags": [
        "車",
        "挑戰",
        "停車",
        "技術"
      ]
    },
    "ja": {
      "title": "リアルカー・パーキング・シミュレーター",
      "description": "リアルカーセミナー・パーキングシミュレーターであなたの運転スキルを試してみましょう。パーキングシミュレーションゲームでは、さまざまなパーキングの挑戦に直面します。リアルなコントロールと詳細な環境で、実際に運転席にいるかのように感じられます。並行駐車から狭いガレージスペースまで、このゲームは多くのパーキングの挑戦を提供します。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "車",
        "挑戦",
        "駐車",
        "スキル"
      ]
    },
    "ko": {
      "title": "실제 자동차 주차 시뮬레이터",
      "description": "Real Car Parking Simulator에서 운전 기술을 테스트해보세요. 주차 시뮬레이션 게임에서 다양한 주차 도전 과제를 맞게 됩니다. 실제적인 조종 장치와 자세한 환경으로, 실제로 운전석에 앉아 있는 것 같은 느낌을 받을 수 있습니다. 평행 주차에서 좁은 주차 공간까지, 이 게임은 많은 주차 도전 과제를 제공합니다.",
      "instructions": "마우스 클릭이나 탭으로 게임 시작",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "カー",
        "挑戦",
        "駐車",
        "スキル"
      ]
    },
    "fr": {
      "title": "Simulateur de Stationnement de Voiture Réelle",
      "description": "Préparez-vous à tester vos compétences en conduite dans le simulateur de stationnement de voiture Real Car Parking Simulator. Dans ce jeu de simulation de stationnement, vous allez faire face à divers défis de stationnement. Avec des contrôles réalistes et des environnements détaillés, vous vous sentirez comme si vous étiez vraiment au volant. Du stationnement en biais à des espaces de garage étroits, ce jeu propose de nombreuses défis de stationnement.",
      "instructions": "Clic ou appui de souris pour jouer",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "car",
        "défi",
        "stationnement",
        "compétence"
      ]
    }
  }
};
